<template>
  <section>
    <div class="moileParticulars">
      <van-nav-bar :title="goods.goodsName" fixed left-text="返回" left-arrow @click-left="$router.back(-1)">
      </van-nav-bar>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
      >

    <van-card v-for="goods in list" :key="goods.id" :title="goods.goodsName"
      :desc="delHtmlTag(goods.goodsDesc)"
      :thumb="goods.pictureShowUrl"
      @click="gotoPlay(goods.id)"
    >
      <template #tags>
        <van-tag plain type="danger">{{formatPer(goods.progressPercent)}}</van-tag>
        <van-tag plain type="danger">{{goods.testHours}}课时</van-tag>
      </template>
    </van-card>
      </van-list>
      </van-pull-refresh>
    </div>
  </section>
</template>
<script>
import "@/../static/js/ckplayer/preview_ckplayer.js";
import { debug } from "util";
import { Dialog } from "vant";
import { Toast } from 'vant';
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      list:[],
      goods:{
        id:'',
        goodsName:'培训班课程'
      }
    };
  },
  methods: {
      //判断是否登录
      judgeLogin(){
          if(this.$sessionStore.getUserId()){
              return true;
          }else{
              return false;
          }

      },
      formatDate: function(dateUnix){
        let dt = new Date(dateUnix);
        let y = dt.getFullYear();
        let m = dt.getMonth() + 1;
        let d = dt.getDate(); 
      return `${y}/${m}/${d}`;
      },
      formatPer: function(per){
        try{
          return parseInt(parseFloat(per) * 100) + "%";
        }catch(e){
          return "0%";
        }
      },
      delHtmlTag(str){
	      return str.replace(/<[^>]+>/g,"");
      },
      getSession(){
          this.$axiosPackag.getMessageByAxios("GET", "/session/getSession", null, null, null, resD => {
              if (resD) {
                  this.$sessionStore.initSession(resD);
              }
          });
      },
      gotoPlay(id){
        this.$router.push({path: "/mobileCourseDetail", query: {id: id}});
      },
      onLoad(){
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            this.page = 1;
          }
          this.$axiosPackag.getMessageByAxios("GET","/goodsInfo/findCourseList",{'packageId':this.goods.id},null,null, result =>{            
            if(result && result.length > 0){
              for (let _r of result) {
                this.list.push(_r);
              }
            }
            this.finished = true;
            this.loading = false;
          },(errorCall) => {
            this.loading = false;
            Toast.fail(errorCall.message);
            this.finished = true;
          });
      },
      onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.onLoad();
    }
  },
  mounted() {
      setInterval(this.getSession(), 1000 * 300);
      let id=this.$route.query.id;
      this.goods.id = id;
  }
};
</script>

<style scoped>
.moileParticulars{width:100%;height:100%;color:#2c333a;background:#f2f2f2;}
.van-card__thumb{width: 140px;}
</style>



// WEBPACK FOOTER //
// MobileClassDetail.vue?3afb0912